<template>
  <div>
    <spinner-three-bounce :displayNone="!purchasePaymentSuccessisLoading"/>

    <div v-if="!purchasePaymentSuccessisLoading" class="row wrapper border-bottom white-bg page-heading">
      <div class="col-lg-10">
        <h2>Nouvelle Commande</h2>
        <ol class="breadcrumb">
          <li>
            <router-link to="/">Accueil</router-link>
          </li>
          <li>
            <router-link to="/">Commande</router-link>
          </li>
          <li class="active">
            <strong> Ajouter une commande</strong>
          </li>
        </ol>
      </div>
      <div class="col-lg-2">
      </div>
    </div>
    <div v-if="!purchasePaymentSuccessisLoading" class="animated fadeInRight wrapper-content">
      <div class="row bloc-information">
        <div v-if="!vehicle"
             class="col-lg-6">
          <div class="ibox float-e-margins">
            <div class="ibox-content col-lg-4" style="min-height: 155px;">
              <div class="img-grey"></div>
            </div>
            <div class="col-lg-8 no-paddings">
              <div class="ibox-title">
                <h4>
                  <a href="#"
                     @click.prevent.stop="addVehicle"
                     style="position: absolute; margin-top: -6px;">
                    <div class="btn btn-primary btn-circle">+</div>&nbsp;Ajouter un véhicule</a>
                </h4>
              </div>
              <div class="ibox-content" style="border-top:none;">
              </div>
            </div>
          </div>
        </div>
        <div v-else
             class="col-lg-6">
          <div class="ibox float-e-margins">
            <div class="ibox-content col-lg-4" style="min-height: 155px;">
              <a :href="vehicleUrl" target="_blank">
                <img :src="vehicle.photo" class="img-vehicle">
              </a>
            </div>
            <div class="col-lg-8 no-paddings">
              <div class="ibox-title">
                <h5 style="position:absolute; width:96%;">
                  <a @click.prevent.stop="addVehicle"><span class="pull-right" style="padding-right:20px;"><i class="fa fa-pencil"></i></span></a>
                  <strong>{{ `${vehicle.make} ${vehicle.model} ${vehicle.version}` }}</strong><br>
                  <span class="orange">{{ selectedAd.buyerPrice.toLocaleString() }} €</span>
                </h5>
              </div>

              <div class="ibox-content" style="border-top:none;">
                <i class="fa fa-road"></i> {{ vehicle.kilometers.toLocaleString() }} km<br>
                <i class="fa fa-money"></i> {{ vehicle.fuel }}<br>
                <i class="fa fa-flag-checkered"></i><span v-if="vehicle.licensePlate"> {{ vehicle.licensePlate }},</span>
                {{ vehicle.year }},
                {{ vehicle.gearType }}, {{ vehicle.city }} ({{ vehicle.department }})<br>
                <a :href="`https://www.carizy.com/pro/edit_expert/${vehicle.appraisalExpert.id}`">
                  <i class="fa fa-user"></i> Expert {{ vehicle.appraisalExpert.name }} le {{ vehicle.appraisalDate | formatDate }}
                </a>
              </div>

            </div>
          </div>
        </div>
        <div class="col-lg-3">
          <div class="ibox float-e-margins">
            <div class="ibox-title">
              <h5>Vendeur</h5>
            </div>
            <div class="ibox-content">
              <template v-if="seller">
                <i class="fa fa-user"></i> {{ seller.firstname + ' ' + seller.lastname }}<br>
                <i class="fa fa-phone"></i> {{ seller.phone }}<br>
                <i class="fa fa-envelope"></i> {{ seller.email }}
              </template>
            </div>
          </div>
        </div>
        <div class="col-lg-3">
          <div class="ibox float-e-margins">
            <div class="ibox-title">
              <h4 v-if="!buyer">
                <a href="#"
                   @click.prevent.stop="addCustomer"
                   style="position: absolute; margin-top: -10px;">
                  <div class="btn btn-primary btn-circle">+</div>&nbsp;
                  Ajouter un Acheteur
                </a>
              </h4>
              <template v-else>
                <a href="#"
                   @click.prevent.stop="addCustomer"><span class="pull-right"><i class="fa fa-pencil"></i></span></a>
                <h5>Acheteur</h5>
              </template>
            </div>
            <div class="ibox-content">
              <template v-if="buyer">
                <i class="fa fa-user"></i> {{ buyer.firstname + ' ' + buyer.lastname }}<br>
                <i class="fa fa-phone"></i> {{ buyer.phone }}<br>
                <i class="fa fa-envelope"></i> {{ buyer.email }}
              </template>
            </div>
          </div>
        </div>
      </div>
      <!-- end -->
      <component-alert v-if="vehicle && daysToExpiry < 15"
                       :type="expiryBanner.type"
                       :label="expiryBanner.message"/>
      <!-- detail de la commande  -->
      <div class="row">
        <div class="col-lg-12">
          <div class="ibox">
            <div class="ibox-content">
              <div class="row">
                <div class="col-sm-8">
                  <h2 class="font-bold">Détail de la commande</h2>
                  <i class="fa fa-circle text-primary"></i>
                  <span> En cours de création</span>
                </div>
                <div class="col-sm-3 pull-right text-right">
                  <div>
                    <label class="control-label" for="commercial">Commercial assigné
                      <select name="commercial"
                              id="commercial"
                              class="form-control m-t-xs"
                              v-model="commercial">
                        <option :value="null">Choisir un commercial</option>
                        <option v-for="commercial in accountManager"
                                :key="commercial.id"
                                :value="commercial.id">{{ commercial.firstname + ' ' + commercial.lastname }}</option>
                      </select>
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- fin Detail de la commande -->

      <component-alert v-if="lemonwayBankFootprintError"
                       type="danger"
                       :label="lemonwayBankFootprintErrorMessage"/>

      <div class="row">
        <div class="col-lg-12">
          <div class="ibox">
            <div class="ibox-title">
              <h5><i class="fa fa-file"></i> Options choisies par l'acheteur</h5>
            </div>
            <div class="ibox-content">
              <div class="table-responsive m-t">
                <table class="table invoice-table table-order">
                  <thead>
                  </thead>
                  <tbody>
                  <tr>
                    <td>
                      <div>
                        <label class="control-label">
                          <select name="options"
                                  class="form-control border-none"
                                  @change="onChangeOptions()"
                                  v-model="options.warranty">
                            <option :value="null">Choisir une garantie</option>
                            <option v-for="option in warrantyOptions"
                                    :key="option.id"
                                    :value="option.id">{{ option.name }}</option>
                          </select>
                        </label>
                      </div>
                    </td>
                    <td>
                      <div v-if="warrantyOptionDisabled && warrantyOptionReference().option">
                        <label class="control-label">
                          <select name="options"
                                  class="form-control border-none"
                                  v-model="options.warrantyOption">
                            <option :value="null">Sans option</option>
                            <option v-for="option in warrantyOptionReference()"
                                    :key="option.reference"
                                    :value="option.reference" v-if="option.reference">{{ option.name }}
                            </option>
                          </select>
                        </label>
                      </div>
                    </td>
                    <td></td>
                    <td>{{ getWarrantyPrice }} €</td>
                  </tr>
                  <tr>
                    <td>
                      <div>
                        <label class="control-label">
                          <select name="options"
                                  class="form-control border-none"
                                  v-model="options.disposalType">
                            <option :value="null">Choisir un mode de cession</option>
                            <option :value="appointmentMode.DELIVERY"
                                    :disabled="!selectedAd || !seller || !buyer">Livraison</option>
                            <option :value="appointmentMode.DISPOSAL">Rendez-vous de cession</option>
                          </select>
                        </label>
                      </div>
                    </td>
                    <td></td>
                    <td></td>
                    <td>{{ getDeliveryPrice }} €</td>
                  </tr>
                  <tr v-show="options.disposalType === 1">
                    <td>
                      <div>
                        <label>
                          <div class="input-group m-b">
                            <span class="input-group-addon"><i class="fa fa-map-marker"></i></span>
                            <gmap-autocomplete ref="gmapAddress"
                                               :componentRestrictions="{'country': ['fr']}"
                                               placeholder="Entrer une adresse postale"
                                               class="form-control"
                                               @change="resetAddress"
                                               @place_changed="(p) => onPlaceChanged(p)"/>
                          </div>
                        </label>
                      </div>
                      <component-alert v-if="completeAddressNeeded"
                                       type="danger"
                                       label="Veuillez saisir une adresse complète pour continuer"/>
                    </td>
                    <td>
                      <spinner-three-bounce :displayNone="!$apollo.queries.calculateFeesForNewOrder.loading"/>
                    </td>
                    <td/>
                    <td/>
                  </tr>
                  <tr>
                    <td>
                      <div>
                        <label class="control-label">
                          <select name="options"
                                  class="form-control border-none"
                                  @change="setCarRegistrationDocumentPrice"
                                  v-model="options.carRegistrationDocument">
                            <option :value="null">Sans Carte grise</option>
                            <option :value="carRegistrationDocumentOption.DOCUMENTWITH">Carte grise </option>
                          </select>
                        </label>
                      </div>
                    </td>
                    <td>
                      <div v-if="options.carRegistrationDocument">
                        <label class="control-label">
                          <input
                              name="zipCode"
                              type="text"
                              class="form-control"
                              placeholder="Saisir un code postal"
                              @input="setCarRegistrationDocumentPrice"
                              v-model="zipCode"
                          />
                        </label>
                      </div>
                    </td>
                    <td></td>
                    <td>{{ getCarRegistrationDocumentPrice }}  €</td>
                  </tr>
                  <tr>
                    <td>
                      <div>
                        <label class="control-label">
                          <select name="options"
                                  class="form-control border-none"
                                  @change="setRegistrationPrice()"
                                  v-model="options.registration">
                            <option :value="null">Sans plaques d’immatriculation</option>
                            <option :value="registrationOption.REGISTRATIONWITH">Plaques d’immatriculation</option>
                          </select>
                        </label>
                      </div>
                    </td>
                    <td>
                      <div v-if="options.registration">
                        <label class="control-label">
                          <select name="options"
                                  class="form-control border-none"
                                  v-model="area">
                            <option :value="null">Choisissez votre région</option>
                            <option v-for="option in areaList"
                                    :key="option.id"
                                    :value="option.id">{{ option.name }}</option>
                          </select>
                        </label>
                      </div>
                    </td>
                    <td>
                      <div v-if="options.registration">
                        <label class="control-label">
                          <select name="options"
                                  class="form-control border-none"
                                  @change="setRegistrationPrice()"
                                  v-model="department">
                            <option :value="null">Choisissez votre département</option>
                            <option v-for="option in filteredAndSorted()"
                                    :key="option.id"
                                    :value="option.id">{{ option.name }}</option>
                          </select>
                        </label>
                      </div>
                    </td>
                    <td>{{ getRegistrationPrice }} €</td>
                  </tr>
                  <tr>
                    <td>
                      <div>
                        <label class="control-label">
                          <select name="options"
                                  class="form-control border-none"
                                  v-model="options.payment">
                            <option :value="null">Choisir un moyen de paiement</option>
                            <option :value="paymentMode.TRANSFER_PAYMENT_MODE">Paiement par virement bancaire</option>
                            <option :value="paymentMode.BANK_CHECK_PAYMENT_MODE">Paiement par chèque de banque</option>
                            <option :value="paymentMode.CREDIT_PAYMENT_MODE_MOBILIZE">Crédit MOBILIZE</option>
                            <option :value="paymentMode.CREDIT_PAYMENT_MODE_COFIDIS">Crédit COFIDIS</option>
                            <option :value="paymentMode.CREDIT_PAYMENT_MODE_YOUNITED">Crédit YOUNITED</option>
                          </select>
                        </label>
                      </div>
                    </td>
                    <td></td>
                    <td></td>
                    <td>{{ gain }} €</td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-12">
          <div class="ibox">
            <div class="ibox-title">
              <h4><i class="fa fa-usd"></i>&nbsp;<span>À payer par l'acheteur</span></h4>
            </div>
            <div class="ibox-content">
              <div class="table-responsive m-t">
                <table class="table">
                  <thead>
                  <tr>
                    <th class="w-50-percent">Détail<br>
                    <th class="text-center">Au vendeur<br>
                      {{ getBuyerToSellerTotalPrice | formatPrice }} € TTC</th>
                    <th class="text-center">À Carizy<br>
                      {{ getBuyerToCarizyTotalPrice | formatPrice }} € TTC</th>
                    <th class="text-navy text-center">Total<br>
                      {{ getBuyerTotalPrice | formatPrice }} € TTC</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-if="vehicle">
                    <td><div>Véhicule</div></td>
                    <td class="text-center">{{ selectedAd.buyerPrice | formatPrice }} €</td>
                    <td class="text-center"></td>
                    <td class="text-center">{{ selectedAd.buyerPrice | formatPrice }} €</td>
                  </tr>
                  <tr>
                    <td><div>Frais de formalité</div></td>
                    <td></td>
                    <td class="text-center"
                        ref="buyer-to-carizy">{{ getFormalityPrice }} €</td>
                    <td class="text-center">{{ getFormalityPrice }} €</td>
                  </tr>
                  <tr v-if="options.warranty">
                    <td><div>{{ getWarrantyLabel }}</div></td>
                    <td></td>
                    <td class="text-center">{{ getWarrantyPrice }} €</td>
                    <td class="text-center">{{ getWarrantyPrice }} €</td>
                  </tr>
                  <tr v-if="options.disposalType">
                    <td><div>{{ getDisposalLabel }}</div></td>
                    <td></td>
                    <td class="text-center">{{ getDeliveryPrice }} €</td>
                    <td class="text-center">{{ getDeliveryPrice }} €</td>
                  </tr>
                  <tr v-if="options.payment">
                    <td><div>{{ getPaymentLabel }}</div></td>
                    <td></td>
                    <td class="text-center">{{ gain }} €</td>
                    <td class="text-center">{{ gain }} €</td>
                  </tr>
                  <tr v-if="options.carRegistrationDocument">
                    <td><div>{{ getCarRegistrationDocumentLabel }} </div></td>
                    <td></td>
                    <td class="text-center">{{ getCarRegistrationDocumentPrice }} €</td>
                    <td class="text-center">{{ getCarRegistrationDocumentPrice }} €</td>
                  </tr>
                  <tr v-if="options.registration">
                    <td><div>{{ getRegistrationLabel }}</div></td>
                    <td></td>
                    <td class="text-center">{{ getRegistrationPrice }} €</td>
                    <td class="text-center">{{ getRegistrationPrice }} €</td>
                  </tr>
                  <tr v-if="getCarRegistrationDocumentEcoTaxPrice !== 0">
                    <td><div>Dont écotaxe</div></td>
                    <td></td>
                    <td class="text-center">{{ getCarRegistrationDocumentEcoTaxPrice }} €</td>
                    <td class="text-center">{{ getCarRegistrationDocumentEcoTaxPrice }} €</td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row ibox">
        <div class="col-lg-12 text-center">
          <button class="btn btn-primary text-center"
                  type="button"
                  @click="onSubmit"
                  :disabled="disableSubmit"><i class="fa fa-check"></i>
            &nbsp;Procéder au paiement de la réservation ({{ getReservationPrice }} €) et enregistrer </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import gql from 'graphql-tag'
  import CommercialList from '../api/query/CommercialList.gql'
  import WarrantyOptionList from '../api/query/WarrantyOptionList.gql'
  import Alert from '../components/Alert.vue'
  import { formatAddress, addressToString } from '../helpers/utils'
  import { appointmentMode, carRegistrationDocument, paymentMode, registration } from '@/helpers/utils/constants'
  import localStorage from '../helpers/mixins/localStorage'
  import store from '../config/store'
  import SpinnerThreeBounce from '@/components/spinners/SpinnerThreeBounce'
  import { isAddressIncompleteMixin } from '@/mixins/isAddressIncompleteMixin'

  const DELIVERY = appointmentMode.DELIVERY
  const DISPOSAL = appointmentMode.DISPOSAL

  const DOCUMENTWITH = carRegistrationDocument.with
  const DOCUMENTWITHOUT = carRegistrationDocument.without
  const REGISTRATIONWITH = registration.with
  const REGISTRATIONWITHOUT = registration.without

  const BANK_CHECK_PAYMENT_MODE = paymentMode.BANK_CHECK_PAYMENT_MODE
  const TRANSFER_PAYMENT_MODE = paymentMode.TRANSFER_PAYMENT_MODE
  const CREDIT_PAYMENT_MODE_MOBILIZE = paymentMode.CREDIT_PAYMENT_MODE_MOBILIZE
  const CREDIT_PAYMENT_MODE_COFIDIS = paymentMode.CREDIT_PAYMENT_MODE_COFIDIS
  const CREDIT_PAYMENT_MODE_YOUNITED = paymentMode.CREDIT_PAYMENT_MODE_YOUNITED

  export default {
    components: {
      'component-alert': Alert,
      SpinnerThreeBounce
    },

    mixins: [isAddressIncompleteMixin],

    data: () => ({
      appointmentMode: {
        DELIVERY: DELIVERY,
        DISPOSAL: DISPOSAL
      },
      carRegistrationDocumentOption: {
        DOCUMENTWITH: DOCUMENTWITH,
        DOCUMENTWITHOUT: DOCUMENTWITHOUT
      },
      registrationOption: {
        REGISTRATIONWITH: REGISTRATIONWITH,
        REGISTRATIONWITHOUT: REGISTRATIONWITHOUT
      },
      paymentMode: {
        BANK_CHECK_PAYMENT_MODE: BANK_CHECK_PAYMENT_MODE,
        TRANSFER_PAYMENT_MODE: TRANSFER_PAYMENT_MODE,
        CREDIT_PAYMENT_MODE_MOBILIZE: CREDIT_PAYMENT_MODE_MOBILIZE,
        CREDIT_PAYMENT_MODE_COFIDIS: CREDIT_PAYMENT_MODE_COFIDIS,
        CREDIT_PAYMENT_MODE_YOUNITED: CREDIT_PAYMENT_MODE_YOUNITED
      },
      accountManager: [],
      warrantyOptions: [],
      areaList: [
        {
          name: "Île-de-France",
          id: "ile-de-france",
        },
        {
          name: "Centre -Val de Loire",
          id: "centre-val-de-loire",
        },
        {
          name: "Bourgogne-Franche-Comté",
          id: "bourgogne-franche-comte",
        },
        {
          name: "Normandie",
          id: "normandie",
        },
        {
          name: "Hauts-de-France",
          id: "hauts-de-france",
        },
        {
          name: "Grand Est",
          id: "grand-est",
        },
        {
          name: "Pays de la Loire",
          id: "pays-de-la-loire",
        },
        {
          name: "Bretagne",
          id: "bretagne",
        },
        {
          name: "Nouvelle Aquitaine",
          id: "nouvelle-aquitaine",
        },
        {
          name: "Occitanie",
          id: "occitanie",
        },
        {
          name: "Auvergne-Rhône-Alpes",
          id: "auvergne-rhone-alpes",
        },
        {
          name: "Provence-Alpes-Côte d'Azur",
          id: "provence-alpes-cote-d-azur",
        },
        {
          name: "Corse",
          id: "corse",
        },
        {
          name: "Guadeloupe",
          id: "guadeloupe",
        },
        {
          name: "Martinique",
          id: "martinique",
        },
        {
          name: "Guyane",
          id: "guyane",
        },
        {
          name: "La Réunion",
          id: "la-reunion",
        },
        {
          name: "Mayotte",
          id: "mayotte",
        },
      ],
      departmentList: [
        {
          name: "94",
          area: 'ile-de-france',
          id: 94,
        },
        {
          name: "75",
          area: 'ile-de-france',
          id: 75
        },
        {
          name: "77",
          area: 'ile-de-france',
          id: 77
        },
        {
          name: "78",
          area: 'ile-de-france',
          id: 78
        },
        {
          name: "91",
          area: 'ile-de-france',
          id: 91
        },
        {
          name: "92",
          area: 'ile-de-france',
          id: 92
        },
        {
          name: "93",
          area: 'ile-de-france',
          id: 93
        },
        {
          name: "95",
          area: 'ile-de-france',
          id: 95
        },
        {
          name: "18",
          area: 'centre-Val-de-loire',
          id: 18
        },
        {
          name: "28",
          area: 'centre-Val-de-loire',
          id: 28
        },
        {
          name: "36",
          area: 'centre-Val-de-loire',
          id: 36
        },
        {
          name: "37",
          area: 'centre-Val-de-loire',
          id: 37
        },
        {
          name: "41",
          area: 'centre-Val-de-loire',
          id: 41
        },
        {
          name: "45",
          area: 'centre-Val-de-loire',
          id: 45
        },
        {
          name: "21",
          area: 'bourgogne-franche-comte',
          id: 21
        },
        {
          name: "25",
          area: 'bourgogne-franche-comte',
          id: 25
        },
        {
          name: "39",
          area: 'bourgogne-franche-comte',
          id: 39
        },
        {
          name: "58",
          area: 'bourgogne-franche-comte',
          id: 58
        },
        {
          name: "70",
          area: 'bourgogne-franche-comte',
          id: 70
        },
        {
          name: "71",
          area: 'bourgogne-franche-comte',
          id: 71
        },
        {
          name: "89",
          area: 'bourgogne-franche-comte',
          id: 89
        },
        {
          name: "90",
          area: 'bourgogne-franche-comte',
          id: 90
        },
        {
          name: "14",
          area: 'normandie',
          id: 14
        },
        {
          name: "27",
          area: 'normandie',
          id: 27
        },
        {
          name: "50",
          area: 'normandie',
          id: 50
        },
        {
          name: "61",
          area: 'normandie',
          id: 61
        },
        {
          name: "76",
          area: 'normandie',
          id: 76
        },
        {
          name: "02",
          area: 'hauts-de-france',
          id: '02'
        },
        {
          name: "59",
          area: 'hauts-de-france',
          id: 59
        },
        {
          name: "60",
          area: 'hauts-de-france',
          id: 60
        },
        {
          name: "62",
          area: 'hauts-de-france',
          id: 62
        },
        {
          name: "80",
          area: 'hauts-de-france',
          id: 80
        },
        {
          name: "08",
          area: 'grand-est',
          id: '08',
        },
        {
          name: "10",
          area: 'grand-est',
          id: 10
        },
        {
          name: "51",
          area: 'grand-est',
          id: 51
        },
        {
          name: "52",
          area: 'grand-est',
          id: 52
        },
        {
          name: "54",
          area: 'grand-est',
          id: 54
        },
        {
          name: "55",
          area: 'grand-est',
          id: 55
        },
        {
          name: "57",
          area: 'grand-est',
          id: 57
        },
        {
          name: "67",
          area: 'grand-est',
          id: 67
        },
        {
          name: "68",
          area: 'grand-est',
          id: 68
        },
        {
          name: "88",
          area: 'grand-est',
          id: 88
        },
        {
          name: "44",
          area: 'pays-de-la-loire',
          id: 44
        },
        {
          name: "49",
          area: 'pays-de-la-loire',
          id: 49
        },
        {
          name: "53",
          area: 'pays-de-la-loire',
          id: 53
        },
        {
          name: "72",
          area: 'pays-de-la-loire',
          id: 72
        },
        {
          name: "85",
          area: 'pays-de-la-loire',
          id: 85
        },
        {
          name: "22",
          area: 'bretagne',
          id: 22
        },
        {
          name: "29",
          area: 'bretagne',
          id: 29
        },
        {
          name: "35",
          area: 'bretagne',
          id: 35
        },
        {
          name: "56",
          area: 'bretagne',
          id: 56
        },
        {
          name: "16",
          area: 'nouvelle-aquitaine',
          id: 16
        },
        {
          name: "17",
          area: 'nouvelle-aquitaine',
          id: 17
        },
        {
          name: "19",
          area: 'nouvelle-aquitaine',
          id: 19
        },
        {
          name: "23",
          area: 'nouvelle-aquitaine',
          id: 23
        },
        {
          name: "24",
          area: 'nouvelle-aquitaine',
          id: 24
        },
        {
          name: "33",
          area: 'nouvelle-aquitaine',
          id: 33
        },
        {
          name: "40",
          area: 'nouvelle-aquitaine',
          id: 40
        },
        {
          name: "47",
          area: 'nouvelle-aquitaine',
          id: 47
        },
        {
          name: "64",
          area: 'nouvelle-aquitaine',
          id: 64
        },
        {
          name: "79",
          area: 'nouvelle-aquitaine',
          id: 79
        },
        {
          name: "86",
          area: 'nouvelle-aquitaine',
          id: 86
        },
        {
          name: "87",
          area: 'nouvelle-aquitaine',
          id: 87
        },
        {
          name: "09",
          area: 'occitanie',
          id: '09'
        },
        {
          name: "11",
          area: 'occitanie',
          id: 11
        },
        {
          name: "12",
          area: 'occitanie',
          id: 12
        },
        {
          name: "30",
          area: 'occitanie',
          id: 30
        },
        {
          name: "31",
          area: 'occitanie',
          id: 31
        },
        {
          name: "32",
          area: 'occitanie',
          id: 32
        },
        {
          name: "34",
          area: 'occitanie',
          id: 34
        },
        {
          name: "46",
          area: 'occitanie',
          id: 46
        },
        {
          name: "48",
          area: 'occitanie',
          id: 48
        },
        {
          name: "65",
          area: 'occitanie',
          id: 65
        },
        {
          name: "66",
          area: 'occitanie',
          id: 66
        },
        {
          name: "81",
          area: 'occitanie',
          id: 81
        },
        {
          name: "82",
          area: 'occitanie',
          id: 82
        },
        {
          name: "01",
          area: 'auvergne-rhone-alpes',
          id: '01'
        },
        {
          name: "03",
          area: 'auvergne-rhone-alpes',
          id: '03'
        },
        {
          name: "07",
          area: 'auvergne-rhone-alpes',
          id: "07"
        },
        {
          name: "15",
          area: 'auvergne-rhone-alpes',
          id: 15
        },
        {
          name: "26",
          area: 'auvergne-rhone-alpes',
          id: 26
        },
        {
          name: "38",
          area: 'auvergne-rhone-alpes',
          id: 38
        },
        {
          name: "42",
          area: 'auvergne-rhone-alpes',
          id: 42
        },
        {
          name: "43",
          area: 'auvergne-rhone-alpes',
          id: 43
        },
        {
          name: "63",
          area: 'auvergne-rhone-alpes',
          id: 63
        },
        {
          name: "69",
          area: 'auvergne-rhone-alpes',
          id: 69
        },
        {
          name: "73",
          area: 'auvergne-rhone-alpes',
          id: 73
        },
        {
          name: "74",
          area: 'auvergne-rhone-alpes',
          id: 74
        },
        {
          name: "04",
          area: 'provence-alpes-cote-d-azur',
          id: '04'
        },
        {
          name: "05",
          area: 'provence-alpes-cote-d-azur',
          id: '05'
        },
        {
          name: "06",
          area: 'provence-alpes-cote-d-azur',
          id: "06"
        },
        {
          name: "13",
          area: 'provence-alpes-cote-d-azur',
          id: 13
        },
        {
          name: "83",
          area: 'provence-alpes-cote-d-azur',
          id: 83
        },
        {
          name: "84",
          area: 'provence-alpes-cote-d-azur',
          id: 84
        },
        {
          name: "2A",
          area: 'corse',
          id: '2A'
        },
        {
          name: "2B",
          area: 'corse',
          id: '2B'
        },
        {
          name: "971",
          area: 'guadeloupe',
          id: 971
        },
        {
          name: "972",
          area: 'martinique',
          id: 972,
        },
        {
          name: "973",
          area: 'guyane',
          id: 973,
        },
        {
          name: "974",
          area: 'la-reunion',
          id: 974
        },
        {
          name: "976",
          area: 'mayotte',
          id: 976,
        }
      ],
      calculateFeesForNewOrder: [],
      fromBO: true,
      selectedAd: null,
      buyer: null,
      commercial: null,
      options: {
        warranty: null,
        warrantyOption: null,
        payment: null,
        disposalType: null,
        carRegistrationDocument: null,
        registration: null,
      },
      area: null,
      department: null,
      deliveryAddress: null,
      purchasePaymentUrl: {
        confirmation: process.env.VUE_APP_BACKOFFICE_CDN_PATH + '/#' + process.env.VUE_APP_COMMAND_CREATE + '/success',
        error: process.env.VUE_APP_BACKOFFICE_CDN_PATH + '/#' + process.env.VUE_APP_COMMAND_CREATE + '/error',
        cancel: process.env.VUE_APP_BACKOFFICE_CDN_PATH + '/#' + process.env.VUE_APP_COMMAND_CREATE + '/cancel'
      },
      purchasePaymentResponseToken: "",
      storage: null,
      purchasePaymentSuccessisLoading: false,
      lemonwayBankFootprintError: false,
      lemonwayBankFootprintErrorMessage: "",
      warrantyOptionDisabled: false,
      orderInfo: {
        registrationPrice: 0,
        registrationCertificatePrice: 0,
        carRegistrationDocumentEcoTaxPrice: 0
      },
      zipCode: '',
      ecotaxe: 'Ecotaxe',
    }),

    computed: {
      vehicleUrl () {
        return process.env.VUE_APP_FRONTOFFICE_DOMAIN + this.vehicle.url
      },

      completeAddressNeeded () {
        return this.options.disposalType === appointmentMode.DELIVERY && this.isAddressIncomplete(this.deliveryAddress)
      },

      gain () {
        return this.calculateFeesForNewOrder.gain
      },

      getFormalityPrice () {
        return this.calculateFeesForNewOrder.formalityPrice
      },

      getWarrantyPrice () {
        return this.calculateFeesForNewOrder.warrantyPrice
      },

      getCarRegistrationDocumentPrice () {
        return this.orderInfo.registrationCertificatePrice
      },
      getCarRegistrationDocumentEcoTaxPrice() {
        return parseFloat(this.orderInfo.carRegistrationDocumentEcoTaxPrice ? this.orderInfo.carRegistrationDocumentEcoTaxPrice : 0)
      },

      getRegistrationPrice () {
        return this.orderInfo.registrationPrice
      },

      getDeliveryPrice () {
        return this.calculateFeesForNewOrder.deliveryPrice
      },

      getWarrantyLabel () {
        const result = this.warrantyOptions.find(o => o.id === this.options.warranty)

        return (undefined === result) ? '' : result.name
      },

      getDisposalLabel () {
        switch (this.options.disposalType) {
          case appointmentMode.DELIVERY:
            return 'Livraison'
          case appointmentMode.DISPOSAL:
            return 'Rendez-vous de cession'
          default:
            return ''
        }
      },

      getCarRegistrationDocumentLabel () {
        switch (this.options.carRegistrationDocument) {
          case carRegistrationDocument.with:
            return 'Carte grise'
          case carRegistrationDocument.without:
            return 'Sans carte grise'
          default:
            return ''
        }
      },

      getRegistrationLabel () {
        switch (this.options.registration) {
          case registration.with:
            return 'Plaques d’immatriculation'
          case registration.without:
            return 'Sans plaques d’immatriculation'
          default:
            return ''
        }
      },

      getPaymentLabel () {
        switch (this.options.payment) {
          case paymentMode.TRANSFER_PAYMENT_MODE:
            return 'Virement bancaire'
          case paymentMode.BANK_CHECK_PAYMENT_MODE:
            return 'Chèque de banque'
          case paymentMode.CREDIT_PAYMENT_MODE_MOBILIZE:
            return 'Crédit MOBILIZE'
          case paymentMode.CREDIT_PAYMENT_MODE_COFIDIS:
            return 'Crédit COFIDIS'
          case paymentMode.CREDIT_PAYMENT_MODE_YOUNITED:
            return 'Crédit YOUNITED'
          default:
            return ''
        }
      },

      getBuyerToCarizyTotalPrice () {
        return this.getWarrantyPrice + this.gain + this.getFormalityPrice + this.getCarRegistrationDocumentPrice + this.getRegistrationPrice
      },

      getBuyerToSellerTotalPrice () {
        let total = 0
        total += this.selectedAd ? this.selectedAd.buyerPrice : 0
        return total
      },

      getBuyerTotalPrice () {
        return this.getBuyerToCarizyTotalPrice + this.getBuyerToSellerTotalPrice
      },

      getReservationPrice () {
        return this.getFormalityPrice + this.gain
      },

      vehicle () {
        return this.selectedAd ? this.selectedAd.vehicle[0] : null
      },

      seller () {
        return this.selectedAd ? this.selectedAd.seller[0] : null
      },

      daysToExpiry () {
        if (!this.vehicle)
          return null
        return moment(this.vehicle.technicalControlValidity).diff(moment(), 'days')
      },

      expiryBanner () {
        if (this.daysToExpiry < 1) {
          return {
            type: 'danger',
            message: 'Le contôle technique de ce véhicule est expiré.'
          }
        }
        return {
          type: 'info',
          message: `Attention, la validité du contrôle technique arrivera à échéance dans ${this.daysToExpiry} jours.`
        }
      },

      disableSubmit () {
        if (!this.selectedAd || !this.commercial || !this.buyer)
          return true
        if (this.completeAddressNeeded)
          return true
        if (!this.options.warranty || !this.options.payment || !this.options.disposalType) return true
        return false
      },

      createBuyer () {
        return gql`
        mutation {
          customer (
          firstName: "${this.buyer.firstname}"
          lastName: "${this.buyer.lastname}"
          email: "${this.buyer.email}"
          phone: "${this.buyer.phone}"
          address: {
            address: "${this.buyer.address.address}"
            zipCode: "${this.buyer.address.zipCode}"
            city: "${this.buyer.address.city}"
          }
          organization: ${this.buyer.organization}
          companyName: "${this.buyer.companyName}"
          coordinate: {
            latitude: ${this.buyer.coordinate.latitude}
            longitude: ${this.buyer.coordinate.longitude}
          }
          )
          {
            id
          }
        }`
      },

      getDeliveryParameters () {
        let addressStart = ""
        let addressEnd = ""
        let bodyType = this.selectedAd.vehicle[0].body

        if(this.seller.address)
          addressStart = addressToString(this.seller.address)
        if(this.buyer.address)
          addressEnd = addressToString(this.buyer.address)
        if(this.deliveryAddress)
          addressEnd = addressToString(this.deliveryAddress)

        return `{
          bodyType: "${bodyType}",
          addressStart: "${addressStart}",
          addressEnd: "${addressEnd}"
        }`
      },
    },

    watch: {
      'options.payment': function () {
        if (this.options.payment === paymentMode.BANK_CHECK_PAYMENT_MODE) {
          this.options.disposalType = appointmentMode.DISPOSAL
        }

        this.$apollo.queries.calculateFeesForNewOrder.refetch()
      },
      'options.disposalType': function () {
        if (this.options.disposalType === appointmentMode.DELIVERY) {
          this.options.payment = paymentMode.TRANSFER_PAYMENT_MODE
        }

        this.$apollo.queries.calculateFeesForNewOrder.refetch()
      },

      accountManager() {
          const userId = this.storage.userInfos.userProfil.id

          if (this.accountManager.some(function(o) {
            return o.id === userId
          })) {
            this.commercial = userId
          }
      }
    },

    mounted () {
      this.$bus.$on('select-ad-success', this.onSelectAdSuccess)
      this.$bus.$on('select-customer-success', this.onSelectCustomerSuccess)
      this.storage = JSON.parse(window.localStorage.getItem(store.localStorageKey))

      this.lemonwayBankFootprintError = false
      this.lemonwayBankFootprintErrorMessage = ""

      if (window.location.href.indexOf("success") > -1) {
        this.purchasePaymentSuccessisLoading = true

        const url = window.location.href.split('?')
        const params = url[1].split('&')

        const result = params.find((e) => {
          return (e.includes('response_wkToken'))
        });

        if (undefined !== result) {
          this.purchasePaymentResponseToken =  result.split('=')[1]

          this.selectedAd = this.storage.pendingOrder.ad
          this.buyer = this.storage.pendingOrder.buyer
          this.options = this.storage.pendingOrder.options
          this.commercial = this.storage.pendingOrder.commercial
          this.calculateFeesForNewOrder = this.storage.pendingOrder.fees
          this.area = this.storage.pendingOrder.area
          this.department = this.storage.pendingOrder.department
          this.orderInfo = this.storage.pendingOrder.orderInfo
          this.zipCode = this.storage.pendingOrder.zipCode

          this.purchasePaymentSuccess()

          delete this.storage.pendingOrder
          localStorage.methods.saveData()
        } else {
          this.showBanner('danger', `Une erreur est survenue, veuillez contacter l'IT`)
        }
      } else if(window.location.href.indexOf("error") > -1) {
        this.purchasePaymentSuccessisLoading = false
        this.lemonwayBankFootprintErrorMessage = "L'empreinte n'a pas pu être effectuée. Veuillez contacter l'IT."
        this.lemonwayBankFootprintError = true
        this.showBanner('danger', `L'empreinte n'a pas pu être effectuée. Une erreur est survenue, veuillez contacter l'IT`)
      } else if(window.location.href.indexOf("cancel") > -1) {
        this.purchasePaymentSuccessisLoading = false
        this.showBanner('danger', `L'opération a été annulée`)
      }
    },

    destroyed () {
      this.$bus.$off('select-ad-success', this.onSelectAdSuccess)
      this.$bus.$off('select-customer-success', this.onSelectCustomerSuccess)
    },

    methods: {
      filteredAndSorted() {
        // function to compare names
        function compare(a, b) {
          if (a.name < b.name) return -1;
          if (a.name > b.name) return 1;
          return 0;
        }
        return this.departmentList.filter(department => {
          return department.area.toLowerCase().includes(this.area?.toLowerCase())
        }).sort(compare)
      },
      async setCarRegistrationDocumentPrice(){
        this.orderInfo.registrationCertificatePrice = 0
        if (!this.zipCode) this.zipCode = this.buyer.address.zipCode
        if (this.selectedAd &&  this.zipCode.length === 5 && this.options.carRegistrationDocument) {
          const eplaquePrice = await this.$apollo.query({
            query: gql`
            query {
                getEplaquePrice (adId: ${this.selectedAd.id}, zip: "${this.zipCode}") {
                  code,
                  message,
                  prices {
                    priceCG
                    ecoTax
                    total
                  }
                }
              }`,
            fetchPolicy: 'no-cache'
          })

          this.orderInfo.registrationCertificatePrice = eplaquePrice.data.getEplaquePrice?.prices?.total
          this.orderInfo.carRegistrationDocumentEcoTaxPrice = eplaquePrice.data.getEplaquePrice?.prices?.ecoTax
        }
      },
      async setRegistrationPrice(){
        if (!this.options.registration) this.orderInfo.registrationPrice = 0
        if (this.department && this.area && this.options.registration) {
          const registrationPrice = await this.$apollo.query({
            query: gql`
            query {
                registrationPrice  {
                  price
                }
              }`,
            fetchPolicy: 'no-cache'
          })

          this.orderInfo.registrationPrice = registrationPrice.data.registrationPrice.price
        }
      },
      async getRegistrationPrice() {
        const orderInfo = await this.$apollo.query({
          query: gql`
                    query {
                     registrationPrice {
                        price
                    }
              }`,
          fetchPolicy: 'no-cache'
        })
      },
      getCalculateFeesForNewOrder() {
        let paramString = '';
        let params = [];

        if (this.selectedAd) {
          params.push(`ad: ${this.selectedAd.id}`);
          params.push(`sellerTransaction: ${this.selectedAd.transaction}`);

          params.push(`isRegistrationDocument: "${this.options.carRegistrationDocument ? true : false}"`);

          params.push(`isRegistration: "${this.options.registration ? true : false}"`);

          if (this.options.warranty && !this.options.warrantyOption) params.push(`warranty: ${this.options.warranty}`);

          if (this.options.warranty && this.options.warrantyOption) params.push(`warranty: ${this.options.warrantyOption}`);

          if (this.options.payment) params.push(`paymentMode: ${this.options.payment}`);
          else params.push(`paymentMode: ${paymentMode.TRANSFER_PAYMENT_MODE}`);

          if (this.options.disposalType === appointmentMode.DELIVERY) {
            params.push(`disposalType: ${this.options.disposalType}`);
            params.push(`delivery: ${this.getDeliveryParameters}`)
          } else params.push(`disposalType: ${appointmentMode.DISPOSAL}`);

        }

        if (params.length) paramString = '(' + params.join(', ') + ')'

        return gql`
          {
            calculateFeesForNewOrder ${paramString} {
              formalityPrice
              warrantyPrice
              gain
              deliveryPrice
              carRegistrationDocumentPrice
              carRegistrationPrice
              total
            }
          }
        `
      },

      addVehicle () {
        this.showModal({
          childVue: 'add-vehicle',
        })
      },

      addCustomer () {
        this.showModal({
          childVue: 'add-customer',
          wrapperClass: 'modal-addwallet',
          dataModel: this.buyer || null
        })
      },

      onSelectAdSuccess (ad) {
        this.selectedAd = ad;
        this.options.warranty = null;
        this.options.warrantyOption = null;
      },

      onSelectCustomerSuccess (customer) {
        this.buyer = customer
        this.deliveryAddress = this.buyer.address
        this.$refs.gmapAddress.$el.value = addressToString(this.deliveryAddress)
      },
      onChangeOptions() {
        this.options.warrantyOption = null
        if (this.options.warranty) this.warrantyOptionDisabled = true
      },
      getWarrantyOptions() {
        function compare(a, b) {
          if (a.name < b.name) return -1;
          if (a.name > b.name) return 1;
          return 0;
        }
        return this.warrantyOptions.filter(option => {
          return option.id.includes(this.options.warranty)
        }).sort(compare)
      },

      warrantyOptionReference() {
        return this.getWarrantyOptions()[0]
      },
      purchasePaymentMutation () {
        let warranty = this.options.warrantyOption ? this.options.warrantyOption : this.options.warranty
        return gql`
          mutation {
            purchasePayment(
              adId: ${this.selectedAd.id},
              warrantyId: ${warranty},
              customerId: ${this.buyer.id},
              deliveryMode: ${this.options.disposalType},
              paymentMode: ${this.options.payment},
              priceDelivery: ${this.getDeliveryPrice},
              carRegistrationDocumentPrice: ${this.getCarRegistrationDocumentPrice},
              registrationPrice: ${this.getRegistrationPrice},
              promoCode: ""
              url: {
                confirmation: "${this.purchasePaymentUrl.confirmation}",
                error: "${this.purchasePaymentUrl.error}",
                cancel: "${this.purchasePaymentUrl.cancel}"
              }
            ) {
              result
              }
           }`
      },

      purchasePaymentSuccessMutation () {
        let warranty = this.options.warrantyOption ? this.options.warrantyOption : this.options.warranty
        let isRegistrationDocument = this.options.carRegistrationDocument ? true : false
        let region = this.area ? `"${this.area}"` : null
        let department =  this.department ? `"${this.department}"` : null
        return gql`
        mutation {
          purchasePaymentSuccess(
            adId: "${this.selectedAd.id}",
            warrantyId: ${warranty},
            customerId: ${this.buyer.id},
            deliveryMode: ${this.options.disposalType},
            paymentMode: ${this.options.payment},
            priceDelivery: ${this.getDeliveryPrice},
            responseToken: "${this.purchasePaymentResponseToken}"
            isRegistrationDocument: ${isRegistrationDocument},
            promoCode: ""
            commercial: "${this.commercial}",
            partnerLead: ${this.buyer.partnerLeadSelected},
            region: ${region},
            department: ${department}
          ) {
            order
            result
            }
         }`
      },

      async onSubmit () {
        if (this.buyer.companyName === undefined) {
          this.buyer.companyName = ""
        }

        let customer = await this.$apollo.mutate({
          mutation: this.createBuyer
        })
        this.buyer.id = customer.data.customer.id

        store.data.pendingOrder = {
          ad: this.selectedAd,
          buyer: this.buyer,
          options: this.options,
          commercial: this.commercial,
          fees: this.calculateFeesForNewOrder,
          area: this.area,
          department: this.department,
          orderInfo: this.orderInfo,
          zipCode: this.zipCode
        }

        localStorage.methods.saveData()

        const result = await this.$apollo.mutate({
          mutation: this.purchasePaymentMutation()
        })

        const url = result.data.purchasePayment.result

        window.open(url, "_self")
      },

      async purchasePaymentSuccess () {
        this.purchasePaymentSuccessIsLoading = true

        const result = await this.$apollo.mutate({
          mutation: this.purchasePaymentSuccessMutation()
        })

        const success = result.data.purchasePaymentSuccess.result

        if (success === "success payment"){
          const orderId = result.data.purchasePaymentSuccess.order

          this.$router.push(`/command/${orderId}`)
          this.showBanner('success', `Commande créée avec succès`)
        } else {
          this.showBanner('danger', `Le paiement n'a pas pu être effectué`)
        }

        this.purchasePaymentSuccessIsLoading = false
      },

      onPlaceChanged (place) {
        this.deliveryAddress = formatAddress(place)

        if (this.isAddressIncomplete(this.deliveryAddress)) {
          this.showBanner('danger', 'Veuillez saisir une adresse complète pour continuer')
        } else {
          this.$apollo.queries.calculateFeesForNewOrder.refetch()
        }
      },

      resetAddress () {
        this.deliveryAddress = null;
      }
    },

    apollo: {
      accountManager: {
        query: CommercialList
      },

      warrantyOptions: {
        query: WarrantyOptionList,
        variables () {
          return {
            adId: this.selectedAd.id,
            fromBO: this.fromBO
          }
        },
      },

      calculateFeesForNewOrder: {
        query () {
          return this.getCalculateFeesForNewOrder()
        },
        skip () {
          return this.completeAddressNeeded
        },
      }
    }

  }
</script>
